import * as types from "../constants/actionTypes";

export const directSchedulingInitialState = {
    providerList: [],
    providerNpiList: [],
    providerNpiListStr: '',
    providerListFailure: false,
    providerListSuccess: false,
    providerListPending: false
};

export default function directSchedulingReducer(state = directSchedulingInitialState, action) {
    switch (action.type) {
        case types.DIRECT_SCHEDULING_PROVIDER_LIST:
            return { ...state, providerListFailure: false, providerListPending: true, providerListSuccess: false };
        case types.DIRECT_SCHEDULING_PROVIDER_LIST_SUCCESS:
            // pull a list of NPIs from the returned model...what I wouldn't give for linq right now...
            //debugger;
            let npiList = action && action.providers && action.providers.map?action.providers.map((p, i) => {
                let ids = p.ProviderIds.filter(id => id.IdType === "PROVIDER NPI");
                return ids && ids.length > 0 ? ids[0].Id : "";
            }).filter(id => id !== ""):"";
            const providerNpiListStr = npiList ? npiList.toString() : '';
            return { ...state, providerList: action.providers, providerNpiList: npiList, providerNpiListStr: providerNpiListStr, providerListFailure: false, providerListSuccess: true, providerListPending: false };
        case types.DIRECT_SCHEDULING_PROVIDER_LIST_FAILURE:
            return { ...state, providerList: [], providerListFailure: true, providerListSuccess: false, providerListPending: false, providerNpiListStr: '' };
        case types.LOGOUT:
            return directSchedulingInitialState;
        default:
            return { ...state };
    }
}
